import React, { useState } from 'react';
import { Dropdown, Avatar, Space, Typography, Button } from 'antd';
import { UserOutlined, LogoutOutlined, ProfileOutlined, LoginOutlined } from '@ant-design/icons';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import LoginModal from './LoginModal';

const { Text } = Typography;

const UserProfile = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [isLoginModalVisible, setIsLoginModalVisible] = useState(false);

  const showLoginModal = () => {
    setIsLoginModalVisible(true);
  };

  const handleLoginCancel = () => {
    setIsLoginModalVisible(false);
  };

  const handleMenuClick = ({ key }) => {
    if (key === 'logout') {
      logout();
      navigate('/');
    } else if (key === 'profile') {
      navigate('/profile'); // Assuming we will create a profile page
    }
  };

  const items = [
    {
      key: 'profile',
      label: '个人中心',
      icon: <ProfileOutlined />,
    },
    {
      type: 'divider',
    },
    {
      key: 'logout',
      label: '退出登录',
      icon: <LogoutOutlined />,
      danger: true,
    },
  ];

  if (!user) {
    return (
      <>
        <Button 
          type="primary" 
          icon={<LoginOutlined />} 
          onClick={showLoginModal}
          ghost
          style={{ color: 'var(--light-color)', borderColor: 'var(--light-color)' }}
        >
          游客
        </Button>
        <LoginModal visible={isLoginModalVisible} onCancel={handleLoginCancel} />
      </>
    );
  }

  return (
    <>
      <Dropdown menu={{ items, onClick: handleMenuClick }} placement="bottomRight">
        <Space style={{ cursor: 'pointer', padding: '0 10px' }}>
          <Avatar 
              src={user.avatarUrl} 
              icon={<UserOutlined />} 
              style={{ backgroundColor: '#87d068' }}
          />
          <div style={{ display: 'flex', flexDirection: 'column', lineHeight: '1.2' }}>
              <Text style={{ color: 'inherit', fontWeight: 500 }}>{user.username || user.realName}</Text>
              {user.level && <Text style={{ color: 'rgba(255,255,255,0.7)', fontSize: '10px' }}>{user.level}</Text>}
          </div>
        </Space>
      </Dropdown>
    </>
  );
};

export default UserProfile;
